import request from '@/utils/request'


// 上传图片
export function upload_image_file(data){
	return request({
		headers:{
			'Content-Type':'application/x-www-form-urlencoded'
		},
		url: '/api/activity/upload_image',
		method: 'POST',
		data: data || {}
	})
}

// 微信上传图片
export function upload_wx_image(data){
	return request({
		url: '/api/activity/upload_wx_image',
		method: 'POST',
		data: data || {}
	})
}

//课程详情页
export function coursedetail(data) {
  return request({
    url: '/api/index/coursedetail',
    method: 'POST',
    data: data || {}
  })
}
//课程购买成功页
export function courseprepare(data) {
  return request({
    url: '/api/index/courseprepare',
    method: 'POST',
    data: data || {}
  })
}
//统计手机验证
export function stat_verify_mobile(data) {
  return request({
    url: '/api/index/stat_verify_mobile',
    method: 'POST',
    data: data || {}
  })
}
//手机号验证
export function save_no_verify_mobile(data) {
  return request({
    url: '/api/index/save_no_verify_mobile',
    method: 'POST',
    data: data || {}
  })
}
//获取手机验证码
export function sendmsg(data) {
  return request({
    url: '/admin/Webapi/sendmsg',
    method: 'POST',
    data: data || {}
  })
}
//验证手机号和验证码
export function subcode(data) {
  return request({
    url: '/admin/Webapi/subcode',
    method: 'POST',
    data: data || {}
  })
}
//免费试学
export function project_click_time(data) {
  return request({
    url: '/api/audition/project_click_time',
    method: 'POST',
    data: data || {}
  })
}
//点击下一步的统计
export function statistic_next(data) {
  return request({
    url: '/api/index/statistic_next',
    method: 'POST',
    data: data || {}
  })
}
//新生报到
export function searchwechat(data) {
  return request({
    url: '/api/index/searchwechat',
    method: 'POST',
    data: data || {}
  })
}
//项目列表
export function getproject(data) {
  return request({
    url: '/api/course/getproject',
    method: 'POST',
    data: data || {}
  })
}
//个人战略-播放页
export function getsubject(data) {
  return request({
    url: '/api/course/getsubject',
    method: 'POST',
    data: data || {}
  })
}
//项目详情
export function projectdetail(data) {
  return request({
    url: '/api/index/projectdetail',
    method: 'POST',
    data: data || {}
  })
}
//项目攻略列表
export function getfaq(data) {
  return request({
    url: '/api/course/getfaq',
    method: 'POST',
    data: data || {}
  })
}
//扩展阅读
export function projectread(data) {
  return request({
    url: '/api/index/projectread',
    method: 'POST',
    data: data || {}
  })
}
//大神导师团
export function getvaluation(data) {
  return request({
    url: '/api/course/getvaluation',
    method: 'POST',
    data: data || {}
  })
}
//自查清单
export function getcheck(data) {
  return request({
    url: '/api/course/getcheck',
    method: 'POST',
    data: data || {}
  })
}
//难词表
export function glossary(data) {
  return request({
    url: '/api/index/glossary',
    method: 'POST',
    data: data || {}
  })
}
//P0任务
export function modifytaskstate(data) {
  return request({
    url: '/api/index/modifytaskstate',
    method: 'POST',
    data: data || {}
  })
}
//项目报告
export function getselfreport(data) {
  return request({
    url: '/api/index/getselfreport',
    method: 'POST',
    data: data || {}
  })
}
//p2任务- 获取数据
export function getprototypedata(data) {
  return request({
    url: '/api/bmreport/getprototypedata',
    method: 'POST',
    data: data || {}
  })
}
//p2任务- 提交数据
export function updateprototypedata(data) {
  return request({
    url: '/api/bmreport/updateprototypedata',
    method: 'POST',
    data: data || {}
  })
}
//p2任务1- 上传图片
export function save_user_head(data) {
  return request({
    url: '/api/bmreport/save_user_head',
    method: 'POST',
    data: data || {}
  })
}
export function save_user_head_image(data) {
  return request({
    url: '/api/bmreport/save_user_head_image',
    method: 'POST',
    data: data || {}
  })
}
//p4任务- 获取数据
export function get_selfstock_data(data) {
  return request({
    url: '/api/brandvalue/get_selfstock_data',
    method: 'POST',
    data: data || {}
  })
}
//p4任务- 提交数据
export function update_selfstock_data(data) {
  return request({
    url: '/api/brandvalue/update_selfstock_data',
    method: 'POST',
    data: data || {}
  })
}
//p4任务- 上传图片
export function upload_image(data) {
  return request({
    url: '/api/brandvalue/upload_image',
    method: 'POST',
    data: data || {}
  })
}
export function save_image(data) {
  return request({
    url: '/api/brandvalue/save_image',
    method: 'POST',
    data: data || {}
  })
}
//个人报告
export function tactic_report(data) {
  return request({
    url: '/api/report/tactic_report',
    method: 'POST',
    data: data || {}
  })
}
// P1任务1 - 获取提交数据
export function getresearchdata(data) {
  return request({
    url: '/api/course/getresearchdata',
    method: 'POST',
    data: data || {}
  })
}
// P1任务1 - 提交数据到远程
export function updateresearchdata(data) {
  return request({
    url: '/api/course/updateresearchdata',
    method: 'POST',
    data: data || {}
  })
}
// P3任务 - 获取提交数据
export function getroadbookdata(data) {
  return request({
    url: '/api/developpath/getroadbookdata',
    method: 'POST',
    data: data || {}
  })
}
// P3任务 - 提交数据到远程
export function updateroadbookdata(data) {
  return request({
    url: '/api/developpath/updateroadbookdata',
    method: 'POST',
    data: data || {}
  })
}
// P3彩蛋 - 获取提交数据
export function coursepmq(data) {
  return request({
    url: '/api/index/coursepmq',
    method: 'POST',
    data: data || {}
  })
}
// P3彩蛋 - 提交数据到远程
export function createcoursepmq(data) {
  return request({
    url: '/api/index/createcoursepmq',
    method: 'POST',
    data: data || {}
  })
}
// 报告页 - 单作业+评论
export function TaskShow(data) {
  return request({
    url: '/api/reply/TaskShow',
    method: 'POST',
    data: data || {}
  })
}
// 报告页 - 点赞 || 取消点赞
export function PraiseSub(data) {
  return request({
    url: '/api/reply/PraiseSub',
    method: 'POST',
    data: data || {}
  })
}
// 报告页 - 标签添加接口
export function LableAdd(data) {
  return request({
    url: '/api/reply/LableAdd',
    method: 'POST',
    data: data || {}
  })
}
// 报告页 - 标签认可或者取消人认可
export function LableSub(data) {
  return request({
    url: '/api/reply/LableSub',
    method: 'POST',
    data: data || {}
  })
}
// 转送音频检验分享码
export function check_gift(data){
    return request({
        url: '/api/gift/check_gift',
        method: 'POST',
        data: data || {}
    })
}
// 报告页 - 回复
export function ReplySub(data){
    return request({
        url: '/api/reply/ReplySub',
        method: 'POST',
        data: data || {}
    })
}
// 播放完成
export function subjectstatus(data){
    return request({
        url: '/api/course/subjectstatus',
        method: 'POST',
        data: data || {}
    })
}
// 新p0任务页获取数据
export function index(data){
  return request({
      url: '/api/task/index',
      method: 'POST',
      data: data || {}
  })
}
// 新p0任务页提交数据
export function subtable(data){
  return request({
      url: '/api/task/subtable',
      method: 'POST',
      data: data || {}
  })
}
// 新p4 t1动态数据
export function p4t1_get_dynamic_data(data){
  return request({
      url: '/api/task/index',
      method: 'POST',
      data: data || {}
  })
}
// // 分享
// export function modifytaskstate(data){
//     return request({
//         url: '/api/sharelog/share_log_stat',
//         method: 'POST',
//         data: data || {}
//     })
// }
// 选修课动态数据级联接口1
export function getprofession(data){
  return request({
      url: '/api/task/index',
      method: 'POST',
      data: data || {}
  })
}
// 选修课动态数据级联接口2
export function getjob(data){
  return request({
      url: '/api/task/index',
      method: 'POST',
      data: data || {}
  })
}
// 纯动态数据接口
export function dynamic_data(data){
  return request({
      url: '/api/task/dynamicData',
      method: 'POST',
      data: data || {}
  })
}
// 项目一任务行业调研--获取行业选项
export function get_select(data){
  return request({
      url: '/admin/card/get_select',
      method: 'POST',
      data: data || {}
  })
}
// 项目一任务行业调研--获取卡片内容
export function get_card(data){
  return request({
      url: '/admin/card/get_card',
      method: 'POST',
      data: data || {}
  })
}
// 项目一任务行业调研--获取行业内容生成的海报
export function buildResearch(data){
  return request({
    url: '/api/task/buildResearch',
    method: 'POST',
    data: data || {}
  })
}

// 返现活动邀请语
export function getWords(data){
  return request({
    url: '/api/Shareactivity/getWords',
    method: 'POST',
    data: data || {}
  })
}

// 返现活动海报
export function getPosters(data){
  return request({
    url: '/api/Shareactivity/getPosters',
    method: 'POST',
    data: data || {}
  })
}

// 领取红包
export function grabRed(data){
  return request({
    url: '/api/Redpackage/grabRed',
    method: 'POST',
    data: data || {}
  })
}

// 活动详情
export function getActivity(data){
  return request({
    url: '/api/Shareactivity/getActivity',
    method: 'POST',
    data: data || {}
  })
}
// 新图片上传接口
export function new_savnew_user_head(data) {
  return request({
    url: '/api/bmreport/save_wx_image',
    method: 'POST',
    data: data || {}
  })
}
// 调研问卷获取接口
export function getCourseSurvey(data) {
  return request({
    url: '/api/index/getCourseSurvey',
    method: 'POST',
    data: data || {}
  })
}
// 调研问卷提交接口
export function courseSurvey(data) {
  return request({
    url: '/api/index/courseSurvey',
    method: 'POST',
    data: data || {}
  })
}

// 课程联报获取接口
export function listOffers(data) {
  return request({
    url: '/api/Joint_Offers/list',
    method: 'POST',
    data: data || {}
  })
}
//分组资料
export function getadmission(data) {
  return request({
    url: '/api/index/getadmission',
    method: 'POST',
    data: data || {}
  })
}
//分组资料提交表单
export function saveadmission(data) {
  return request({
    url: '/api/index/saveadmission',
    method: 'POST',
    data: data || {}
  })
}



//-------新动态分组表单接口-------


//（新动态分组表单接口）获取行业
export function getIProfession(data) {
  return request({
    url: '/api/user/getprofession',
    method: 'POST',
    data: data || {}
  })
}
//（新动态分组表单接口）获取职级
export function getIJob(data) {
  return request({
    url: '/api/user/getjob',
    method: 'POST',
    data: data || {}
  })
}
//（新动态分组表单接口）获取职能
export function getIFunctions(data) {
  return request({
    url: '/api/user/getfunctions',
    method: 'POST',
    data: data || {}
  })
}
//（新动态分组表单接口）获取分组资料配置
export function geIUser(data) {
  return request({
    url: '/api/user/getuser',
    method: 'POST',
    data: data || {}
  })
}
//（新动态分组表单接口）提交分组信息
export function setIUser(data) {
  return request({
    url: '/api/user/setuser',
    method: 'POST',
    data: data || {}
  })
}

// 拼团 -- 发起拼团
export function createScrabble(data) {
  return request({
    url: '/api/index/createScrabble',
    method: 'POST',
    data: data || {}
  })
}
// 拼团 -- 参团接口
export function joinScrabble(data) {
  return request({
    url: '/api/index/joinScrabble',
    method: 'POST',
    data: data || {}
  })
}
// 拼团 -- 邀请好友
export function inviteScrabble(data) {
  return request({
    url: '/api/index/inviteScrabble',
    method: 'POST',
    data: data || {}
  })
}
// 拼团 -- 前端支付成功后调取接口
export function paySuccess(data) {
  return request({
    url: '/api/index/paySuccess',
    method: 'POST',
    data: data || {}
  })
}
// 课程测验页面请求
export function audioTest(data) {
  return request({
    url: '/api/project/audioTest',
    method: 'POST',
    data: data || {}
  })
}
// 验页面、自由对话、案例提交
export function testSubmit(data) {
  return request({
    url: '/api/project/testSubmit',
    method: 'POST',
    data: data || {}
  })
}
// 案例分析
export function explainTest(data) {
  return request({
    url: '/api/project/explainTest',
    method: 'POST',
    data: data || {}
  })
}
// 自由对话获取
export function taskTest(data) {
  return request({
    url: '/api/project/taskTest',
    method: 'POST',
    data: data || {}
  })
}
// 获取关关卡信息
export function getLevel(data) {
  return request({
    url: '/api/Project/getLevel',
    method: 'POST',
    data: data || {}
  })
}
// 助教基础数据
export function getBasicData(data) {
  return request({
    url: '/api/tutor/getBasicData',
    method: 'POST',
    data: data || {}
  })
}

// 助教学员作业
export function getUserData(data) {
  return request({
    url: '/api/tutor/getUserData',
    method: 'POST',
    data: data || {}
  })
}

// 每日一问获取数据
export function getQuizStatList(data) {
  return request({
    url: '/api/tutor/getQuizStatList',
    method: 'POST',
    data: data || {}
  })
}

// 每日一问添加数据
export function updateQuizStat(data) {
  return request({
    url: '/api/tutor/updateQuizStat',
    method: 'POST',
    data: data || {}
  })
}

// 删除每日一问添加数据
export function deleteStat(data) {
  return request({
    url: '/api/tutor/deleteStat',
    method: 'POST',
    data: data || {}
  })
}

// 小组讨论获取
export function getDiscStatList(data) {
  return request({
    url: '/api/tutor/getDiscStatList',
    method: 'POST',
    data: data || {}
  })
}
// 小组讨论更改接口
export function updateDIscStat(data) {
  return request({
    url: '/api/tutor/updateDIscStat',
    method: 'POST',
    data: data || {}
  })
}
// 获取海报配置
export function get_poster_config(data) {
  return request({
    url: '/admin/shengya/get_poster_config',
    method: 'POST',
    data: data || {}
  })
}

// 生成海报
export function create_poster(data) {
  return request({
    url: '/admin/shengya/create_poster',
    method: 'POST',
    data: data || {}
  })
}